require("utility/sliding_drawer.scss");

class SlidingDrawer extends React.Component {
  render() {
    var drawerClasses = 'slideDrawer closed'

    if (this.props.show) {
      drawerClasses = 'slideDrawer open'
    }

    return (
      <div className={drawerClasses}>
        <div className='optionalHeader'>Optional activities</div>
        {this.props.content}
      </div>);
  }
}

;

SlidingDrawer.propTypes = StrictPropTypes({
  show: PropTypes.bool,
  content: PropTypes.array,
});

module.exports = SlidingDrawer;


// WEBPACK FOOTER //
// ./modules/components/utility/SlidingDrawer.js